import { render, staticRenderFns } from "./TempAccounts.vue?vue&type=template&id=c9d70cc6"
import script from "./TempAccounts.vue?vue&type=script&lang=ts"
export * from "./TempAccounts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports